
import { MenuComponent } from "@/assets/ts/components/index";
import KTLoader from "@/components/Loader.vue";
import {
  asideEnabled,
  contentWidthFluid,
  loaderEnabled,
  loaderLogo,
  subheaderDisplay,
  themeDarkLogo,
  themeLightLogo,
  toolbarDisplay,
} from "@/core/helpers/config";
import { removeModalBackdrop } from "@/core/helpers/dom";
import { reinitializeComponents } from "@/core/plugins/keenthemes";
import HtmlClass from "@/core/services/LayoutService";
import KTAside from "@/layout/aside/Aside.vue";
import KTDrawerMessenger from "@/layout/extras/DrawerMessenger.vue";
import KTScrollTop from "@/layout/extras/ScrollTop.vue";
import KTHeader from "@/layout/header/Header.vue";
import { Actions } from "@/store/enums/StoreEnums";
import { AuthModule } from "@/store/modules";
import { computed, defineComponent, nextTick, onMounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { getModule } from "vuex-module-decorators";

export default defineComponent({
  name: "Layout",
  components: {
    KTAside,
    KTHeader,
    KTScrollTop,
    KTDrawerMessenger,
    KTLoader,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const authModule = getModule(AuthModule, store);

    const cachedViews = [
      "servicios-prestados-listado",
      "servicios-programados-listado",
      "profesionales-listado",
      "profesionales-listado-ca",
      "familias-listado",
      "menores-listado",
      "servicios-solicitudes-listado",
      "formularios-profesionales-list",
      "formularios-familias-list",
      "profesionales-listado-modificacion",
      "proyectos-n2-listado",
      "personal-listado",
    ];

    // show page loading
    store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");

    // initialize html element classes
    HtmlClass.init();

    const pageTitle = computed(() => {
      return store.getters.pageTitle;
    });

    const breadcrumbs = computed(() => {
      return store.getters.pageBreadcrumbPath;
    });

    onMounted(() => {
      //check if current user is authenticated
      if (!authModule.isAuthenticated) {
        router.push({ name: "sign-in" });
      }

      nextTick(() => {
        reinitializeComponents();
      });

      // Simulate the delay page loading
      setTimeout(() => {
        // Remove page loader after some time
        store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
      }, 500);
    });

    watch(
      () => route.path,
      () => {
        MenuComponent.hideDropdowns(undefined);

        // check if current user is authenticated
        if (!authModule.isAuthenticated) {
          router.push({ name: "sign-in" });
        }

        nextTick(() => {
          reinitializeComponents();
        });
        removeModalBackdrop();
      }
    );

    return {
      cachedViews,
      toolbarDisplay,
      loaderEnabled,
      contentWidthFluid,
      loaderLogo,
      asideEnabled,
      subheaderDisplay,
      pageTitle,
      breadcrumbs,
      themeLightLogo,
      themeDarkLogo,
    };
  },
});
